import React from 'react';
import { getUploadLeadsResponse } from '@pharmaplan/common';
import { useAppSelector } from '../../../../hooks/useAppSelector';

const UploadLeadsError = () => {
  const uploadLeadsResponse = useAppSelector(getUploadLeadsResponse);

  const { errors } = uploadLeadsResponse ?? {};

  return (
    <>
      {errors.map((item) =>
        (
          <div key={item}>{item}</div>
        ))}
    </>
  );
};

export default UploadLeadsError;
